// extracted by mini-css-extract-plugin
module.exports = {"skeleton_img_wrapper":"EventImageSkeleton_skeleton_img_wrapper__nws7P","normal_img_skeleton":"EventImageSkeleton_normal_img_skeleton__N__MP"};